import type { OrganisationUsers } from '../reducers/customer'

export const FETCH_SUBTREES = 'FETCH_SUBTREES'
interface FetchSubtrees {
  type: typeof FETCH_SUBTREES,
  accessToken: string
}

export const FETCH_ORGANISATION_NAME = 'FETCH_ORGANISATION_NAME'
interface FetchOrganisationName {
  type: typeof FETCH_ORGANISATION_NAME,
  accessToken: string,
  id: string
}

export const FETCH_API_KEYS = 'FETCH_API_KEYS'
interface FetchApiKeys {
  type: typeof FETCH_API_KEYS,
  accessToken: string,
  includeExpired: boolean
}

export const REQUEST_API_KEY = 'REQUEST_API_KEY'
interface RequestApiKey {
  type: typeof REQUEST_API_KEY,
  accessToken: string,
  expiresAt: Date,
  organisations: string[]
}

export const FORCE_EXPIRE_API_KEY = 'FORCE_EXPIRE_API_KEY'
interface ForceExpireApiKey {
  type: typeof FORCE_EXPIRE_API_KEY,
  accessToken: string,
  id: string
}

export interface Subtree {
  uuid: string
  name: string
  services: string[]
  children: Subtree[]
}
export const SUBTREES_FETCHED = 'SUBTREES_FETCHED'
interface SubtreesFetched { 
  type: typeof SUBTREES_FETCHED,
  subtrees: Subtree[],
  total: number
}

export interface OrganisationName {
  translated: string[],
  uuid: string
}

export const FETCHED_ORGANISATION_NAME = 'FETCHED_ORGANISATION_NAME'
interface FetchedOrganisationName {
  type: typeof FETCHED_ORGANISATION_NAME,
  organisation: OrganisationName
}

export interface ApiKey {
  id: string,
  expiresAt: Date,
  organisations: string[]
}
export const FETCHED_API_KEYS = 'FETCHED_API_KEYS'
interface FetchedApiKeys {
  type: typeof FETCHED_API_KEYS,
  keys: ApiKey[],
  total: number
}

export interface NewApiKey {
  public_id: string,
  api_key: string,
  expires_at_utc: Date,
}
export interface OrganisationUser {
  firstName: string;
  lastName: string;
  role: string;        
  email: string;
  registered: Date; 
  teams: string[];    
};
export interface OrganisationVehicle {
  mainboxId: string,
  vehicleName: string;
  baseVehicleName: string;
  brandName: string;
  model: string;        
  year: string;
  licenseNumber: Date; 
  addedDate: string,
  teams: string[];    
};
export const RECEIVED_NEW_API_KEY = 'RECEIVED_NEW_API_KEY'
interface ReceivedNewApiKey {
  type: typeof RECEIVED_NEW_API_KEY,
  key: NewApiKey
}

export const EXPIRED_API_KEY_BY_FORCE = 'EXPIRED_API_KEY_BY_FORCE'
interface ExpiredApiKeyByForce {
  type: typeof EXPIRED_API_KEY_BY_FORCE,
  id: string
}

export type SelectedOrganisations = string[]

export const SET_SELECTED_ORGANISATIONS = 'SET_SELECTED_ORGANISATIONS'
interface SetSelectedOrganisation {
  type: typeof SET_SELECTED_ORGANISATIONS,
  uuids: SelectedOrganisations
}

export const APP_STARTED = 'APP_STARTED' 

interface AppStarted {
  type: typeof APP_STARTED,
  token: string,
  email: string
}

export const AUTHENTICATED_USER_FETCHED = 'AUTHENTICATED_USER_FETCHED' 

interface AuthenticatedUserFetched {
  type: typeof AUTHENTICATED_USER_FETCHED,
  token: string,
  user: object,
  isNewUser: boolean
}

export const ADD_CHILD_NODE = 'ADD_CHILD_NODE'
interface AddChildNode {
  type: typeof ADD_CHILD_NODE,
  token: string,
  parentId: string,
  name: string
}

export const CHILD_NODE_ADDED = 'CHILD_NODE_ADDED'
interface ChildNodeAdded {
  type: typeof CHILD_NODE_ADDED,
  uuid: string,
  name: string,
  parentId: string,
}

export const REMOVE_CHILD_NODE = 'REMOVE_CHILD_NODE'
interface RemoveChildNode{
  type: typeof REMOVE_CHILD_NODE,
  token: string,
  id: string,
}

export const CHILD_NODE_REMOVED = 'CHILD_NODE_REMOVED'
interface ChildNodeRemoved {
  type: typeof CHILD_NODE_REMOVED,
  id: string,
}

export const EDIT_CHILD_NODE = 'EDIT_CHILD_NODE'
interface EditChildNode{
  type: typeof EDIT_CHILD_NODE,
  token: string,
  id: string,
  newName: string
}

export const CHILD_NODE_EDITED = 'CHILD_NODE_EDITED'
interface ChildNodeEdited {
  type: typeof CHILD_NODE_EDITED,
  id: string,
  newName: string
}

export const ADD_USER_TO_CHILD_NODE = 'ADD_USER_TO_CHILD_NODE'
interface AddUserToChildNode {
  type: typeof ADD_USER_TO_CHILD_NODE,
  token: string,
  id: string,
  firstName: string,
  lastName: string,
  email: string,
  privilege: string | undefined
}

export const REMOVE_USER_FROM_CHILD_NODE = 'REMOVE_USER_FROM_CHILD_NODE'
interface RemoveUserFromOrganisation {
  type: typeof REMOVE_USER_FROM_CHILD_NODE,
  token: string,
  email: string,
  organisation: string,
  name: string
}

export const USER_FROM_CHILD_NODE_REMOVED = 'USER_FROM_CHILD_NODE_REMOVED'
interface ChildNodeUserRemoved {
  type: typeof USER_FROM_CHILD_NODE_REMOVED,
  email: string,
  organisation: string
}


export const USER_TO_CHILD_NODE_ADDED = 'USER_TO_CHILD_NODE_ADDED'
interface UserHasBeenAdded {
  type: typeof USER_TO_CHILD_NODE_ADDED,
  id: string,
  firstName: string,
  lastName: string,
  email: string,
  privilege: string | undefined
}
export const ORGANISATION_NODE_SELECTED = 'ORGANISATION_NODE_SELECTED'
interface OrganisationNodeSelected {
  type: typeof ORGANISATION_NODE_SELECTED,
  id: string,
}
export const GET_USERS_FROM_NODE = 'GET_USERS_FROM_NODE'
interface GetUsersFromNode {
  type: typeof GET_USERS_FROM_NODE,
  token: string,
  uuid: string
}
export const FETCH_ORGANISATION_NODE_USERS = 'FETCH_ORGANISATION_NODE_USERS'
interface FetchedOrganisationNodeUsers {
  type: typeof FETCH_ORGANISATION_NODE_USERS,
  id: string,
  users: OrganisationUsers[]
}

export const UPDATE_USER_PRIVILEGE = 'UPDATE_USER_PRIVILEGE'
interface UpdateUserPrivilege {
  type: typeof UPDATE_USER_PRIVILEGE,
  token: string,
  email: string,
  tags: string,
  id: string,
  privilege: string
}
export const UPDATED_PRIVILEGE_TO_USER = 'UPDATED_PRIVILEGE_TO_USER'
interface UpdatePrivilegeToUser {
  type: typeof UPDATED_PRIVILEGE_TO_USER,
  id: string,
  email: string,
  privilege: string
}

export const MODIFY_VEHICLE_TO_CHILD_NODE = 'MODIFY_VEHICLE_TO_CHILD_NODE'
interface ModifyVehicleToOrganisation {
  type: typeof MODIFY_VEHICLE_TO_CHILD_NODE,
  token: string,
  id: string,
  vehicleName: string,
  model: string,
  year: string,
  licenseNumber: string, 
  organisation: string
  shouldRemove: boolean
}

export const VEHICLE_TO_CHILD_NODE_ADDED = 'VEHICLE_TO_CHILD_NODE_ADDED'
interface VehicleTochildNodeAdded {
  type: typeof VEHICLE_TO_CHILD_NODE_ADDED,
  id: string,
  vehicleName: string,
  model: string,
  year: string,
  licenseNumber: string, 
  organisation: string
}

export const VEHICLE_TO_CHILD_NODE_REMOVED = 'VEHICLE_TO_CHILD_NODE_REMOVED'
interface VehicleTochildNodeRemoved {
  type: typeof VEHICLE_TO_CHILD_NODE_REMOVED,
  id: string,
  organisation: string
}
export const MOVE_USER_TO_CHILD_NODE = 'MOVE_USER_TO_CHILD_NODE'
interface MoveUserToChildNode {
  type: typeof MOVE_USER_TO_CHILD_NODE,
  token: string,
  email: string,
  uuid: string,
  privilege: string,
  name: string
  parentUuid: string
}

export const MOVE_USER_TO_CHILD_NODE_FAILED = 'MOVE_USER_TO_CHILD_NODE_FAILED'
export interface MoveUserToChildNodeFailed {
  type: typeof MOVE_USER_TO_CHILD_NODE_FAILED
  payload: {name: string, email: string; error?: string, code: number }
}

export const CLEAR_FAILED_USER = 'CLEAR_FAILED_USER'
interface ClearFailedEmailAction {
  type: typeof CLEAR_FAILED_USER;
  payload: string; 
}

export const CLEAR_ALL_ERRORS = 'CLEAR_ALL_ERRORS'
interface ClearAllErrorsAction {
  type: typeof CLEAR_ALL_ERRORS;
  payload: string; 
}
export const USER_FROM_CHILD_NODE_MOVED = 'USER_FROM_CHILD_NODE_MOVED'
interface UserHasBeenMoved {
  type: typeof USER_FROM_CHILD_NODE_MOVED,
  email: string,
  uuid: string,
  privilege: string
  name: string,
}

export const GET_ALL_USERS_FROM_ORGANISATION = 'GET_ALL_USERS_FROM_ORGANISATION'
interface GetAllUsersFromOrganisation {
  type: typeof GET_ALL_USERS_FROM_ORGANISATION,
  token: string,
  orgId: string
}
export const FETCHED_USERS_FROM_ORGANISATION = 'FETCHED_USERS_FROM_ORGANISATION'
interface FetchedUsersFromOrganisation {
  type: typeof FETCHED_USERS_FROM_ORGANISATION,
  orgId: string,
  users: OrganisationUser[],
  total: number
}

export const GET_ALL_VEHICLES_FROM_ORGANISATION = 'GET_ALL_VEHICLES_FROM_ORGANISATION'
interface GetAllVehiclesFromOrganisation {
  type: typeof GET_ALL_VEHICLES_FROM_ORGANISATION,
  token: string,
  orgId: string
}
export const FETCHED_VEHICLES_FROM_ORGANISATION = 'FETCHED_VEHICLES_FROM_ORGANISATION'
interface FetchedVehiclesFromOrganisation {
  type: typeof FETCHED_VEHICLES_FROM_ORGANISATION,
  orgId: string,
  vehicles: OrganisationVehicle[],
  total: number
}

export const FETCH_ORGANISATION_TOOL_CONFIG = 'FETCH_ORGANISATION_TOOL_CONFIG'
interface FetchOrganisationToolConfig {
  type: typeof FETCH_ORGANISATION_TOOL_CONFIG,
  token: string,
  orgId: string
}

export const FETCHED_ORGANISATION_TOOL_CONFIG = 'FETCHED_ORGANISATION_TOOL_CONFIG'
interface FetchedOrganisationToolConfig {
  type: typeof FETCHED_ORGANISATION_TOOL_CONFIG,
  toolConfig: ToolConfiguration,
  orgId: string
}

export interface ToolConfiguration {
  brands: string[],
  categories: ToolCategory[],
  equipmentNames: string[],
  customBrands: boolean,
  customCategories: boolean,
  customEquipmentNames: boolean
};

export interface ToolCategory {
  name: string,
  iconUrl: string
}


export type CustomerActionTypes = FetchSubtrees | FetchOrganisationName | FetchApiKeys | RequestApiKey | ForceExpireApiKey | SubtreesFetched | FetchedOrganisationName | FetchedApiKeys | ReceivedNewApiKey | ExpiredApiKeyByForce | SetSelectedOrganisation | AppStarted | AuthenticatedUserFetched | AddChildNode | ChildNodeAdded | RemoveChildNode | ChildNodeRemoved | AddUserToChildNode | UserHasBeenAdded | OrganisationNodeSelected | FetchedOrganisationNodeUsers | GetUsersFromNode | UpdatePrivilegeToUser | UpdateUserPrivilege | ModifyVehicleToOrganisation | VehicleTochildNodeAdded | RemoveUserFromOrganisation | ChildNodeUserRemoved | VehicleTochildNodeRemoved | MoveUserToChildNode | UserHasBeenMoved | EditChildNode | ChildNodeEdited | MoveUserToChildNodeFailed | ClearFailedEmailAction | ClearAllErrorsAction | GetAllUsersFromOrganisation | FetchedUsersFromOrganisation | GetAllVehiclesFromOrganisation | FetchedVehiclesFromOrganisation | FetchOrganisationToolConfig | FetchedOrganisationToolConfig